import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { DiscardChangesModalProps } from './discardChangesModal.types';

const DiscardChangesModal = ({
  isOpen,
  title = LangEnum.GLOBAL_DISCARD_CHANGES_TITLE,
  description = LangEnum.GLOBAL_DISCARD_CHANGES_DESCRIPTION,
  confirmLabel = LangEnum.GLOBAL_DISCARD,
  testId,
  confirmTestId,
  onConfirm,
  onCancel,
}: DiscardChangesModalProps) => {
  const { translate } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      size="compact"
      testId={testId}
      header={{ title }}
      onClose={onCancel}
      footer={{
        primaryAction: {
          label: confirmLabel,
          variant: 'destructive',
          testId: confirmTestId,
          onClick: onConfirm,
        },
        secondaryAction: { label: LangEnum.GLOBAL_CANCEL_LABEL, onClick: onCancel },
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {translate(description)}
      </Typography>
    </Modal>
  );
};

export default DiscardChangesModal;
